export type UseGoogleTagManagerProps = {
  enabled: boolean;
  code: string;
  slug: string;
}

export function useGoogleTagManager({ enabled, code, slug }: UseGoogleTagManagerProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      {(slug !== 'tocantins') && <script async src='https://tagmanager.alright.network/manager/js/container_IPxf9GaY.js' />}
      {code && <script key='google-tag-manager' async type='text/javascript' src={`https://www.googletagmanager.com/gtm.js?id=${code}`} />}
    </>
  )
}
